import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { ClerkProvider } from '@clerk/clerk-react'
import "./style.css";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY
const prefersDark = typeof window !== 'undefined'
  && window.matchMedia('(prefers-color-scheme: dark)').matches

if (process.env.REACT_APP_NODE_ENV === "production") {
  console.log = () => { };
}
if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}
// Service worker is network-only (see public/service-worker.js). Set REACT_APP_DISABLE_SERVICE_WORKER=true to skip registration.
// Deploy tip: serve index.html with Cache-Control: no-store, no-cache, must-revalidate so browsers always pick up new HTML.
// if (
//   "serviceWorker" in navigator &&
//   process.env.REACT_APP_DISABLE_SERVICE_WORKER !== "true"
// ) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/service-worker.js")
//       .then((reg) => console.log("SW registered", reg))
//       .catch((err) => console.error("SW failed", err));
//   });
// }

ReactDOM.createRoot(document.getElementById('root')).render(
  <>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      appearance={{
        layout: {
          logoImageUrl: prefersDark ? '/logo-dark.svg' : '/logo-light.svg',
          logoLinkUrl: '/',
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </>,
)
//  start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
